const DEFAULT_WEEKDAY_ABBR = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
const RUSSIAN_WEEKDAY_ABBR = ["ВС", "ПН", "ВТ", "СР", "ЧТ", "ПТ", "СБ"];

export function getEventWeekdayAbbr(dayIndex, language = "en") {
  const normalizedLanguage = String(language || "en").toLowerCase();
  const labels = normalizedLanguage.startsWith("ru")
    ? RUSSIAN_WEEKDAY_ABBR
    : DEFAULT_WEEKDAY_ABBR;

  return labels[Number(dayIndex)] || labels[0];
}

